<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-complete-info`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M38 2a2 2 0 012 2l-.001 22h-4L36 6H8v36h12v4H6a2 2 0 01-2-2V4a2 2 0 012-2h32zm2.264 28.95l1.414 1.414a1 1 0 010 1.414l-9.9 9.9a.996.996 0 01-.53.277l-.118.014h-.118a.996.996 0 01-.648-.291l-5.657-5.657a1 1 0 010-1.414l1.414-1.415a1 1 0 011.415 0l3.535 3.536 7.778-7.778a1 1 0 011.415 0zM23 22a1 1 0 011 1v2a1 1 0 01-1 1H13a1 1 0 01-1-1v-2a1 1 0 011-1h10zm8-8a1 1 0 011 1v2a1 1 0 01-1 1H13a1 1 0 01-1-1v-2a1 1 0 011-1h18z"/></svg>
</template>
<script>

export default {
  name: 'IconCompleteInfo',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
